<template>
  <div class="DialogConfirmVerifiedPayment__Component">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">וידוא תשלום</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <p>האם להשלים את ההסבות עבור {{ reports.length }} דוחות נבחרים?</p>
        <ul v-if="reportNumbers && reportNumbers.length">
          <li v-for="num in reportNumbers" :key="num">{{ num }}</li>
        </ul>
      </section>
      <footer class="modal-card-foot">
        <b-button
          :loading="isLoading"
          @click="save"
          label="אישור"
          type="is-primary"
        />
        <b-button :disabled="isLoading" label="ביטול" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import ReportService from '@/services/ReportService';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'DialogConfirmVerifiedPayment',
  props: ['reports', 'reportNumbers', 'onSuccess'],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    save() {
      this.isLoading = true;
      ReportService.completeTransfers(this.reports)
        .then((res) => {
          this.$emit('close');
          if (this.onSuccess) this.onSuccess();
          const successful = res.data && res.data.SuccessfulReports ? res.data.SuccessfulReports.length : this.reports.length;
          const failed = res.data && res.data.FailedReports ? res.data.FailedReports.length : 0;
          Toast.open({
            type: failed === 0 ? 'is-success' : 'is-warning',
            message: failed === 0
              ? 'הפעולה בוצעה!'
              : `הפעולה בוצעה עבור ${successful} דוחות. ${failed} דוחות נכשלו.`,
            duration: 4000,
          });
        })
        .catch(() => {
          Toast.open({
            type: 'is-danger',
            message: 'לא היה ניתן לבצע את הפעולה, יש לפנות לתמיכה הטכנית.',
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
